module.exports = __webpack_public_path__ + "static/media/orders_example.d847e373.csv";